import { Channel, IChannel } from './channel';

export class Channels {
	public static parse(data: IChannels): Channels {
		const channels: Channels = new Channels();
		if ((data.value !== undefined) && (data.value.length > 0)) {
			for (const value of data.value) {
				const channel: Channel = Channel.parse(value);
				if (channel) {
					channels.value.push(channel);
				}
			}
		}
		return channels;
	}
	public value: Channel[] = [];

	public get(id: string): Channel | null {
		for (const channel of this.value) {
			if (channel.id === id) {
				return channel;
			}
		}
		return null;
	}

	public getChannelByName(name: string): Channel | null {
		for (const channel of this.value) {
			if (channel.displayName === name) {
				return channel;
			}
		}
		return null;
	}

	public ignore(name: string): void {
		const channels: Channel[] = [];
		for (const channel of this.value) {
			if (channel.displayName !== name) {
				channels.push(channel);
			}
		}
		this.value = channels;
	}
}

export interface IChannels {
	value?: IChannel[];
}
